<script>
export default {
  data() {
    return {
      widerrufsbelehrung_html: ''
    }
  },
  mounted() {
    let _this = this;
    fetch("https://www.rueden.de/_widerrufsbelehrung.html")
        .then(response => response.text())
        .then(response => {
          _this.widerrufsbelehrung_html = response
        })
  }
}
</script>
<template>
	<b-modal id="modal-widerrufsbelehrung" title="Widerrufsbelehrung" size="lg" :ok-only="true" :ok-title="'schließen'">
    <div v-html="widerrufsbelehrung_html"></div>
	</b-modal>
</template>
